var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3"},[_c('div',{staticClass:"alert alert-warning"},[_c('h4',[_vm._v("Redirecting... Please Wait.")])])])}]

export { render, staticRenderFns }